import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetExamDetail = () => {
	const {idx} = useParams()

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()
	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		fetchRequest('GET', `/${rolePath}/exam/${idx}/detail`)
	}, [])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'exam_idx')
					setAlert('필기 시험 idx 입력 양식을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('필기 시험 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [fetchResult]
}

export default useGetExamDetail
